import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReallocationSource } from '../../../types/reallocation/Reallocation'
import { deleteReallocation } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import reallocationQueryKeys from './reallocationQueryKeys'
import invalidateReportQueries from './invalidateReportQueries'

export const useDeleteReallocation = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (reallocation: ReallocationSource) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return deleteReallocation(companyId, reallocation.id)
    },
    onSuccess: (_data, reallocation) => {
      queryClient.setQueryData<ReallocationSource[]>(reallocationQueryKeys.list({ companyId }), old =>
        old ? old.filter(item => item.id !== reallocation.id) : old
      )
      invalidateReportQueries(queryClient)
    },
    onError: error => {
      console.error('Failed to delete reallocation:', error)
    }
  })
}
